import React from 'react'
import { Stack } from '@mui/material'
import { GoogleLoginButton } from '../GoogleLoginButton/GoogleLoginButton'

/**
 * Google only, matching `apps/platform`'s `SocialLogin`.
 *
 * Sign in with Apple was removed here for parity: the platform's SignInPage
 * keeps its Apple button behind `VITE_ENABLE_APPLE_LOGIN`, which is set in no
 * env file, so the platform has always been Google-only in practice. This app
 * was the outlier, offering Apple unconditionally.
 *
 * The platform's gate is not cosmetic and applies identically here — the WorkOS
 * Apple connection runs on WorkOS's SHARED default credential
 * (`com.workos.default.production.signinwithapple`). Apple scopes the stable
 * `sub` to the DEVELOPER TEAM, so moving to Vera's own Services ID returns a new
 * `sub` for the same Apple ID with `email` null, orphaning every account created
 * on the borrowed credential. See the long comment in
 * `apps/platform/src/pages/onboarding/SignInPage/SignInPage.tsx`. Each Apple
 * signup taken now is an account lost at the switch, so removing the button
 * costs nothing and prevents that.
 *
 * ⚠️ IF THIS APP IS EVER WRAPPED NATIVELY FOR iOS, APPLE MUST COME BACK.
 * App Store Review Guideline 4.8 requires Sign in with Apple wherever an iOS app
 * offers a third-party sign-in such as Google. This is a web surface today, so
 * 4.8 does not apply — but `apps/vera-app` exists and App Store distribution is
 * being pursued, and shipping Google-without-Apple in a native wrapper is a
 * rejection cause.
 */
export const SocialLoginButtons = () => {
  return (
    <Stack spacing={2} width="100%">
      <GoogleLoginButton />
    </Stack>
  )
}
